import axiosIns from '@/libs/axiosIns'

export default {
    namespaced: true,
    state: {
      token: null,
      userId: null,
    },
    mutations: {
      setToken(state, token) {
        state.token = token
      },
      setUserId(state, userId) {
        state.userId = userId
      },
      clearAuthData(state) {
        state.token = null
        state.userId = null
        localStorage.removeItem('token') // Optional: Clear token from localStorage
      },
    },
    getters: {
      getUserId: state => state.userId,
      getToken: state => state.token,
    },
    actions: {
      // Clears everything scoped to the current user's session: the auth token itself plus the
      // permissions/taxonomies, current user, and Youngs/messaging caches from other modules.
      // Without this, switching accounts via the SPA (logout -> login as someone else, no full
      // page reload) left stale permission- and assignment-driven UI (e.g. message icons/actions)
      // showing the PREVIOUS user's data until a manual hard refresh reset the whole JS runtime.
      resetSession({ state, commit }) {
        commit('clearAuthData', state)
        commit('users/resetState', null, { root: true })
        commit('initialData/resetState', null, { root: true })
        commit('youngs/resetState', null, { root: true })
      },
      logout({ dispatch }, router) {
        return new Promise(resolve => {
          axiosIns.post('Auth/LogOut', {})
            .then(response => {
              // Clear auth data and resolve response
              dispatch('resetSession')
              resolve(response)
            })
            .catch(error => {
              // Handle the error if needed, or log it
              console.error('Logout failed:', error)
            })
            .finally(() => {
              // Always redirect to the login page and clear auth data
              dispatch('resetSession')
              router.push({ name: 'login' })
            })
        })
      },
      register({ commit }, data) {
        return new Promise((resolve, reject) => {
          axiosIns.post('Auth/Register', data)
            .then(response => {
              commit('users/addUserMutation', response.data, { root: true })
              resolve(response)
            })
          .catch(error => reject(error))
        })
      },
    },
  }
